import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white text-gray-800 shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={logoImage}
              alt="Robin Hood Roma Logo"
              className="h-20 w-auto mr-3 rounded-sm"
            />
            {/* <span className="text-xl font-bold tracking-tight text-orange-600">Robin Hood Roma ODV</span> */}
          </Link>

          {/* Hamburger menu button for mobile */}
          <button
            className="xl:hidden focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex xl:items-center xl:space-x-3">
            <Link to="/" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Home
            </Link>
            <Link to="/chi-siamo-storie" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Chi Siamo e Storie
            </Link>
            <Link to="/organizzazione" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Organizzazione
            </Link>
            <Link to="/eventi" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Eventi
            </Link>
            <Link to="/progetti-iniziative" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Progetti e Iniziative
            </Link>
            <Link to="/malattie-rare" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Malattie Rare
            </Link>
            <Link
              to="/news"
              className="py-2 px-3 bg-green-600 text-white text-sm rounded-md font-semibold hover:bg-green-700 transition-colors animate-pulse whitespace-nowrap"
            >
              News
            </Link>
            <Link to="/sostienici" className="py-2 px-3 bg-red-600 text-white rounded-md font-bold text-sm uppercase hover:bg-red-700 transition-colors whitespace-nowrap">
              SOSTIENICI E DONA!
            </Link>
            <Link to="/partners" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Partners
            </Link>
            <Link to="/contatti" className="py-2 px-2 text-sm text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap">
              Contatti
            </Link>
          </nav>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="xl:hidden pb-4">
            <div className="flex flex-col space-y-2">
              <Link
                to="/"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Home
              </Link>
              <Link
                to="/chi-siamo-storie"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Chi Siamo
              </Link>
              <Link
                to="/malattie-rare"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Malattie Rare
              </Link>
              <Link
                to="/eventi"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Eventi
              </Link>
              <Link
                to="/progetti-iniziative"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Progetti ed Iniziative
              </Link>
              <Link
                to="/partners"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Partners
              </Link>
              <Link
                to="/news"
                className="py-2 px-4 bg-green-600 text-white rounded-md font-semibold hover:bg-green-700 transition-colors mb-2 animate-pulse"
                onClick={toggleMenu}
              >
                News
              </Link>
              <Link
                to="/organizzazione"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Consiglio Direttivo
              </Link>
              <Link
                to="/sostienici"
                className="py-2 px-3 bg-red-600 text-white rounded-md font-bold text-base uppercase hover:bg-red-700 transition-colors"
                onClick={toggleMenu}
              >
                SOSTIENICI E DONA!
              </Link>
              <Link
                to="/contatti"
                className="py-2 hover:bg-gray-100 px-3 rounded transition-colors"
                onClick={toggleMenu}
              >
                Contatti
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

